import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/products')({
  staticData: {
    permissionSection: 'catalog',
    section: 'Production Planning',
    breadcrumb: 'Products',
  },
  component: () => <Outlet />,
});
